<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Admin Panel
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/mydashboard">My Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active">Admin Panel</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <i
                            data-feather="layers"
                            class="i_icon_st la-clipboard-list las lab font-medium-3"
                          ></i>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Admin Panel
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 px-0">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div
                      class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both"
                    >
                      <nav class="nav-tabs-wrapper main_divtabsview">
                        <ul
                          class="tabs_masters_detailstabing_pills nav nav-pills nav-pill-primary pt-1 nav-tabs-items dragscroll"
                        >
                          <li
                            class="nav-item tabs-item active main_divtabsviewtoggle"
                            data-day="1"
                          >
                            <a
                              class="nav-link active"
                              id="scenario_tab"
                              data-toggle="tab"
                              href="#scenario_master"
                              aria-expanded="true"
                              @click="getScenarios"
                              >Scenario
                              <button class="btn" @click="toggleScenarios">
                                <i class="las la-plus mastercreateicon"></i>
                              </button>
                            </a>
                          </li>
                          <li
                            class="nav-item tabs-item main_divtabsviewtoggle"
                            data-day="3"
                          >
                            <a
                              class="nav-link"
                              id="stc_contacts_tab"
                              data-toggle="tab"
                              href="#stc_contacts"
                              aria-expanded="false"
                              @click="getStcContacts"
                              >STC Contacts
                              <button
                                class="btn btn-secondary"
                                @click="toggleStcContact"
                              >
                                <i class="las la-plus mastercreateicon"></i>
                              </button>
                            </a>
                          </li>
                          <li
                            class="nav-item tabs-item main_divtabsviewtoggle"
                            data-day="3"
                          >
                            <a
                              class="nav-link"
                              id="escalation_tab"
                              data-toggle="tab"
                              href="#escalation_matrix"
                              aria-expanded="false"
                              @click="getEscalationList"
                              >Escalation Matrix
                              <button
                                class="btn btn-secondary"
                                @click="toggleEscalationMatrix"
                              >
                                <i class="las la-plus mastercreateicon"></i>
                              </button>
                            </a>
                          </li>
                          <li
                            class="nav-item tabs-item main_divtabsviewtoggle"
                            data-day="3"
                          >
                            <a
                              class="nav-link"
                              id="upload_tab"
                              data-toggle="tab"
                              href="#upload"
                              aria-expanded="false"
                              @click=""
                              >Upload
                              <button
                                class="btn btn-secondary"
                                @click="toggleUpload"
                              >
                                <i class="las la-upload mastercreateicon"></i>
                              </button>
                            </a>
                          </li>
                        </ul>
                      </nav>
                      <div class="nav-tabs-buttons">
                        <i
                          class="las la-angle-left nav-tabs-arrow nav-tabs-arrow-left material-icons"
                        ></i>
                        <i
                          class="las la-angle-right nav-tabs-arrow nav-tabs-arrow-right material-icons"
                        ></i>
                      </div>
                    </div>

                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane active"
                        id="scenario_master"
                        aria-labelledby="scenario_tab"
                        aria-expanded="true"
                      >
                        <div class="container px-0" v-if="scenario_master">
                          <div class="row mx-0">
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3 mb-1">
                              <label class="form-label text-left w-100">
                                Scenario Title</label
                              >
                              <input
                                class="form-control"
                                v-model="scenarioForm.title"
                                type="text"
                                placeholder="Enter Scenario Title "
                              />
                              <div
                                class="errorinputmsg text-left"
                                v-if="!getTrimmedString(scenarioForm.title)"
                              >
                                Required field
                              </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3 mb-1">
                              <label class="form-label text-left w-100">
                                Scenario Description</label
                              >
                              <input
                                class="form-control"
                                v-model="scenarioForm.description"
                                type="text"
                                placeholder="Enter Scenario Description "
                              />
                              <div
                                class="errorinputmsg text-left"
                                v-if="
                                  !getTrimmedString(scenarioForm.description)
                                "
                              >
                                Required field
                              </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3 mb-1">
                              <label class="form-label text-left w-100">
                                Level Applicable
                              </label>
                              <input
                                class="form-control"
                                style="width: 20px"
                                v-model="scenarioForm.is_level"
                                type="checkbox"
                              />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3 mb-1">
                              <label class="form-label text-left w-100">
                              </label>
                              <button
                                class="btn btn-primary"
                                @click="senarioSubmit"
                                :disabled="!validateScenario()"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <vue-element-loading :active="isMasterListLoading" />
                          <div class="table-responsive datatableview">
                            <table
                              class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                            >
                              <thead class="header-primary">
                                <tr class="thfirst_dock_performance">
                                  <th scope="col" class="text-center">Sr.No</th>
                                  <th scope="col" class="text-left">
                                    Scenario
                                  </th>
                                  <th scope="col" class="text-left">
                                    Description
                                  </th>
                                  <th scope="col" class="text-center">
                                    Created At
                                  </th>
                                  <th scope="col" class="text-center">
                                    Updated At
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(data, index) in scenario_Details.list"
                                >
                                  <tr>
                                    <td data-column="Sr.No">
                                      {{
                                        index +
                                        1 +
                                        scenario_Details.currPageNum *
                                          scenario_Details.pagelimit
                                      }}
                                    </td>
                                    <td
                                      data-column="Scneario"
                                      class="text-left"
                                    >
                                      {{ data.scenario }}
                                    </td>
                                    <td
                                      data-column="Description"
                                      class="text-left"
                                    >
                                      {{ data.description }}
                                    </td>
                                    <td data-column="Created At">
                                      {{
                                        formatTimeStampToMonth(data.created_at)
                                      }}
                                    </td>
                                    <td data-column="Updated At">
                                      {{
                                        formatTimeStampToMonth(data.updated_at)
                                      }}
                                    </td>
                                  </tr>
                                </template>
                                <template v-if="!scenario_Details.list.length">
                                  <tr>
                                    <td colspan="14" style="text-align: center">
                                      No records found
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                          <div
                            class="pageCenter text-center mt-4 pagination_viewallpages"
                          >
                            <pagination
                              v-model="scenario_Details.page"
                              :records="scenario_Details.totalcount"
                              :per-page="scenario_Details.pagelimit"
                              @paginate="
                                (e) => handlePageChange(e, 'scenario_Details')
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        class="tab-pane"
                        id="stc_contacts"
                        role="tabpanel"
                        aria-labelledby="stc_contacts_tab"
                        aria-expanded="false"
                      >
                        <div>
                          <vue-element-loading :active="isMasterListLoading" />
                          <div class="table-responsive datatableview">
                            <table
                              class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                            >
                              <thead class="header-primary">
                                <tr class="thfirst_dock_performance">
                                  <template>
                                    <th class="text-left align-middle">
                                      Sr.No
                                    </th>
                                    <th class="text-left align-middle">Zone</th>
                                    <th class="text-left align-middle">EDC</th>
                                    <th
                                      class="text-left align-middle"
                                      style="min-width: 220px"
                                    >
                                      EDC Contact Details
                                    </th>
                                    <th
                                      class="text-left align-middle"
                                      style="min-width: 220px"
                                    >
                                      STC Details
                                    </th>
                                    <th
                                      class="text-left align-middle"
                                      style="min-width: 220px"
                                    >
                                      Network Details
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(
                                    data, index
                                  ) in stc_contact_Details.list"
                                >
                                  <tr>
                                    <td
                                      data-column="Sr.No"
                                      class="text-left merge_column_detals"
                                      style="width: 100px"
                                    >
                                      {{
                                        index +
                                        1 +
                                        stc_contact_Details.currPageNum *
                                          stc_contact_Details.pagelimit
                                      }}
                                    </td>
                                    <td
                                      data-column="Zone"
                                      class="text-left merge_column_detals"
                                    >
                                      {{ data.zone }}
                                    </td>
                                    <td
                                      data-column="EDC"
                                      class="text-left merge_column_detals"
                                    >
                                      {{ data.edc }}
                                    </td>
                                    <td
                                      data-column="EDC Contact Details"
                                      class="text-left merge_column_detals"
                                    >
                                      <div class="meger_details">
                                        <span class="title_name_text"
                                          >EDC Contact No :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.edc_contact
                                        }}</span>
                                      </div>
                                      <div class="meger_details">
                                        <span class="title_name_text">
                                          EDC Head :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.edch
                                        }}</span>
                                      </div>
                                      <div class="meger_details">
                                        <span class="title_name_text">
                                          EDC Head Contact :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.edch_contact
                                        }}</span>
                                      </div>
                                    </td>
                                    <td
                                      data-column="STC Details"
                                      class="text-left merge_column_detals"
                                    >
                                      <div class="meger_details">
                                        <span class="title_name_text"
                                          >STC :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.stc
                                        }}</span>
                                      </div>
                                      <div class="meger_details">
                                        <span class="title_name_text"
                                          >STC Manager :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.stc_manager
                                        }}</span>
                                      </div>
                                      <div class="meger_details">
                                        <span class="title_name_text">
                                          STC Contact No :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.stc_contact
                                        }}</span>
                                      </div>
                                    </td>
                                    <td
                                      data-column="Network Details"
                                      class="text-left merge_column_detals"
                                    >
                                      <div class="meger_details">
                                        <span class="title_name_text"
                                          >Network Manager :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.network_manager
                                        }}</span>
                                      </div>
                                      <div class="meger_details">
                                        <span class="title_name_text">
                                          Network Contact :</span
                                        >
                                        <span class="title_value_text">{{
                                          data.network_contact
                                        }}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                                <template
                                  v-if="!stc_contact_Details.list.length"
                                >
                                  <tr>
                                    <td colspan="14" style="text-align: center">
                                      No records found
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                          <div
                            class="pageCenter text-center mt-4 pagination_viewallpages"
                          >
                            <pagination
                              v-model="stc_contact_Details.page"
                              :records="stc_contact_Details.totalcount"
                              :per-page="stc_contact_Details.pagelimit"
                              @paginate="
                                (e) =>
                                  handlePageChange(e, 'stc_contact_Details')
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        class="tab-pane"
                        id="escalation_matrix"
                        role="tabpanel"
                        aria-labelledby="escalation_tab"
                        aria-expanded="false"
                      >
                        <div>
                          <vue-element-loading :active="isMasterListLoading" />
                          <div class="table-responsive datatableview">
                            <table
                              class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                            >
                              <thead class="header-primary">
                                <tr class="thfirst_dock_performance">
                                  <th scope="col" class="text-center">S.No</th>
                                  <th scope="col" class="text-center">
                                    Scenario
                                  </th>
                                  <th scope="col" class="text-center">
                                    Total Escalation Level
                                  </th>
                                  <th scope="col" class="text-center">
                                    created time
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(
                                    data, index
                                  ) in escalation_config_Details.list"
                                >
                                  <tr @click="toggle(data.scenario_id)">
                                    <td data-column="S.No" class="text-center">
                                      {{ index + 1 }}
                                    </td>
                                    <td
                                      data-column="Scenario"
                                      class="text-center"
                                    >
                                      {{ data.scenario }}
                                    </td>
                                    <td
                                      data-column="Total Escalation Level"
                                      class="text-center"
                                    >
                                      {{ data.totalEscalationLevel }}
                                    </td>
                                    <td
                                      data-column="created time"
                                      class="text-left"
                                    >
                                      {{
                                        formatTimeStampToMonth(data.createdTime)
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      colspan="100%"
                                      style="padding: 0px !important"
                                    >
                                      <div
                                        v-if="opened === data.scenario_id"
                                        class="table-responsive datatableview"
                                        style="padding: 10px !important"
                                      >
                                        <table
                                          class="opened table table-hover table_stickys table-col-td-white custom_doctable"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                class="text-left align-middle"
                                              >
                                                N Level Escalation
                                              </th>
                                              <th
                                                class="text-left align-middle"
                                              >
                                                Action Time
                                              </th>
                                              <th
                                                class="text-left align-middle"
                                              >
                                                Call Receivers
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template>
                                              <tr
                                                v-for="list in data.scenarioDetails"
                                              >
                                                <td
                                                  data-column=" N Level Escalation"
                                                  class="text-left"
                                                >
                                                  {{ list.n_level_escalation }}
                                                </td>
                                                <td
                                                  data-column="Action Time"
                                                  class="text-left"
                                                >
                                                  {{
                                                    convertMinutesToTime3(
                                                      list.action_time_minutes
                                                    )
                                                  }}
                                                </td>
                                                <td
                                                  data-column="Call Receivers"
                                                  class="text-left"
                                                >
                                                  {{
                                                    dataChangeToString(
                                                      list.call_receivers
                                                    )
                                                  }}
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                                <template
                                  v-if="!escalation_config_Details.list.length"
                                >
                                  <tr>
                                    <td colspan="14" style="text-align: center">
                                      No records found
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                          <div
                            class="pageCenter text-center mt-4 pagination_viewallpages"
                          >
                            <pagination
                              v-model="escalation_config_Details.page"
                              :records="escalation_config_Details.totalcount"
                              :per-page="escalation_config_Details.pagelimit"
                              @paginate="
                                (e) =>
                                  handlePageChange(
                                    e,
                                    'escalation_config_Details'
                                  )
                              "
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        id="upload"
                        role="tabpanel"
                        aria-labelledby="upload_tab"
                        aria-expanded="false"
                      >
                        <div>
                          <div class="container px-0">
                            <div class="row mx-0">
                              <div
                                class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                              >
                                <label class="form-label text-left w-100"
                                  >Master Upload Name</label
                                >
                                <treeselect
                                  :clearable="false"
                                  clear="false"
                                  placeholder="Select Master Upload Name"
                                  v-model="masterUploadName"
                                  :options="masterUploadNameList"
                                  @select="updateTemplateList"
                                />
                              </div>
                              <div
                                class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 intelilinkuploadbtn-right"
                              >
                                <label class="form-label text-left w-100">
                                  &nbsp;</label
                                >
                                <label
                                  for="attachment"
                                  class="btn btn-relief-success mb-0 intelilinkuploadbtn"
                                  >Choose File</label
                                >
                                <input
                                  type="file"
                                  id="attachment"
                                  hidden
                                  ref="file"
                                  accept=".xlsx, .xls, .csv, .txt"
                                  @change="onFileSelect($event)"
                                />
                                <button
                                  class="btn btn-relief-info ml-1 uploadbutton intelilinkuploadbtn"
                                  v-on:click.stop.prevent="
                                    saveUploadData($event)
                                  "
                                  :disabled="!master.upload.isValidated"
                                  :class="{
                                    'cursor-not-allowed':
                                      master.upload.isValidated === false,
                                  }"
                                >
                                  <upload-icon
                                    size="1.5x"
                                    class="custom-class avatar-icon font-medium-2 mr-50"
                                  >
                                  </upload-icon>
                                  <span>Upload</span>
                                </button>
                                <!-- :disabled="!master.upload.isValidated" -->
                                <button
                                  class="btn btn-outline-dark clearButton ml-1 intelilinkuploadbtn"
                                  v-on:click.stop.prevent="
                                    resetTemplateFileUploadData($event)
                                  "
                                >
                                  <x-circle-icon
                                    size="1.5x"
                                    class="custom-class avatar-icon font-medium-2 mr-50"
                                  ></x-circle-icon>
                                  Clear
                                </button>
                                <div style="font-weight: 600" class="mt-2">
                                  {{
                                    master.upload.fileName
                                      ? master.upload.fileName
                                      : "No file selected"
                                  }}
                                </div>
                                <div
                                  style="font-weight: 500; color: green"
                                  class="mt-2"
                                  v-if="
                                    textFileReports.includes(masterUploadName)
                                  "
                                >
                                  Only .txt files are allowed.
                                </div>
                                <div
                                  v-else
                                  style="font-weight: 500; color: green"
                                  class="mt-2"
                                >
                                  Only .xls, .xlsx, .csv files are allowed.
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div
                                  class="row"
                                  style="
                                    align-items: center;
                                    justify-content: space-evenly;
                                    font-weight: bold;
                                  "
                                >
                                  <div>
                                    Success:
                                    <span style="color: green">{{
                                      this.master.upload.success
                                    }}</span>
                                  </div>
                                  <div>
                                    Failed:
                                    <span style="color: red">{{
                                      this.master.upload.failed
                                    }}</span>
                                  </div>
                                  <div>
                                    Updated:
                                    <span style="color: orange">{{
                                      this.master.upload.updated
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8 mt-2"
                              >
                                <button
                                  class="btn btn-outline-secondary ml-1 mb-1 intelilinkuploadbtn"
                                  @click="getTemplateFile()"
                                >
                                  <file-icon
                                    size="1.5x"
                                    class="custom-class avatar-icon font-medium-2 mr-50"
                                  ></file-icon>
                                  GET Template
                                </button>
                              </div>
                            </div>
                            <div class="card" id="document-list">
                              <div class="card-body p-0 ps ps--active-x">
                                <div class="table-responsive datatableview">
                                  <vue-element-loading
                                    spinner="bar-fade-scale"
                                    :active="isLoading"
                                  />
                                  <table
                                    class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                                    aria-describedby="mydesc"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          class="text-center first-col-sticky"
                                          style="
                                            min-width: 45px;
                                            padding-right: 5px;
                                            padding-left: 5px;
                                          "
                                        >
                                          SR. NO.
                                        </th>
                                        <th
                                          scope="col"
                                          class="text-center second-col-sticky"
                                        >
                                          File Name
                                        </th>
                                        <th scope="col" class="text-center">
                                          Created By
                                        </th>
                                        <th scope="col" class="text-center">
                                          Created Date
                                        </th>
                                        <th scope="col" class="text-center">
                                          Download
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <vue-element-loading
                                        :active="isMasterListLoading"
                                      />
                                      <template
                                        v-for="(data, index) in master.upload
                                          .documentList"
                                      >
                                        <tr v-bind:key="index">
                                          <td
                                            class="text-center first-col-sticky"
                                          >
                                            {{
                                              index +
                                              1 +
                                              master.upload.currPageNum *
                                                master.upload.pagelimit
                                            }}
                                          </td>
                                          <td
                                            class="text-center second-col-sticky"
                                          >
                                            {{ data.file_name }}
                                          </td>
                                          <td class="text-center">
                                            {{
                                              convertEmailIdToName(
                                                data.createdby
                                              )
                                            }}
                                          </td>
                                          <td class="text-center">
                                            {{
                                              formatTimeStampToMonth(
                                                data.createddate
                                              )
                                            }}
                                          </td>
                                          <td class="text-center">
                                            <a
                                              @click="
                                                getDownloadedLink(data.file_key)
                                              "
                                              target="_blank"
                                              class="btn btn-icon btn-icon btn-flat-secondary waves-effect"
                                            >
                                              <div
                                                class="d-flex align-items-center sitebluecolor"
                                              >
                                                <download-icon
                                                  size="1.5x"
                                                  class="custom-class"
                                                  style="color: #00cfe8"
                                                ></download-icon>
                                              </div>
                                            </a>
                                          </td>
                                        </tr>
                                      </template>
                                      <template
                                        v-if="
                                          master.upload.documentList.length == 0
                                        "
                                      >
                                        <tr>
                                          <td
                                            colspan="14"
                                            style="text-align: center"
                                          >
                                            No record found
                                          </td>
                                        </tr>
                                      </template>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="pageCenter text-center mt-4">
                                  <pagination
                                    v-model="master.upload.page"
                                    :records="master.upload.totalcount"
                                    :per-page="master.upload.pagelimit"
                                    @paginate="clickCallbackBulkUploadPage"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div
        class="col-md-6 col-12 modal modal-slide-in fade col-12 show"
        id="addbutton"
      >
        <div class="modal-dialog sidebar-lg">
          <div class="modal-content p-0">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              style="color: #ffff !important"
            >
              ×
            </button>
            <div
              class="modal-header mb-1"
              style="
                background-color: #8c564b !important;
                border-radius: 0 !important;
              "
            >
              <h5 class="modal-title" style="color: #ffff !important">
                <span class="align-middle ml-50">
                  {{
                    master.forms.map_dock_to_sector.isEdit ? "Update" : "Add"
                  }}
                  Dock to Sector Mapping</span
                >
              </h5>
            </div>
            <div class="modal-body flex-grow-1 devUniqueForm p-0">
              <form class="form form-vertical">
                <div class="row mx-0">
                  <div class="col-12 form-group">
                    <label for="dock_id"
                      >Dock Name <span class="requiredField">*</span></label
                    >
                    <treeselect
                      placeholder="Enter min 2 chars to search Dock Name"
                      v-model="master.forms.map_dock_to_sector.dock_id"
                      :options="master.forms.map_dock_to_sector.dockList"
                      v-on:search-change="dockNameSearch"
                    />
                    <div
                      class="errorinputmsg"
                      v-if="!master.forms.map_dock_to_sector.dock_id"
                    >
                      Required field
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label for="zone_id"
                      >Sector Name <span class="requiredField">*</span></label
                    >
                    <treeselect
                      placeholder="Enter min 2 chars to search zone Name"
                      v-model="master.forms.map_dock_to_sector.zone_id"
                      :options="
                        master.forms.map_dock_to_sector.filterDockWiseZoneList
                      "
                      v-on:search-change="zoneNameSearch"
                      multiple
                    />
                    <div
                      class="errorinputmsg"
                      v-if="!master.forms.map_dock_to_sector.zone_id"
                    >
                      Required field
                    </div>
                  </div>
                  <div class="col-12 mg-top1">
                    <button
                      type="button"
                      class="btn btn-relief-primary mr-1"
                      tabindex="4"
                      @click="onSelectDoc()"
                      :disabled="!validateForm()"
                    >
                      {{
                        this.master.forms.map_dock_to_sector.isEdit
                          ? "Update"
                          : "Save"
                      }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="resetform()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
import schema from "../../utils/schema";
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";

export default {
  name: "AdminPanel",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      un: "",
      opened: null,
      isOpened: false,
      isLoading: false,
      expandedIndex: null,
      isShipmentsSyncing: false,
      isMasterListLoading: true,
      pagefeatures: [],
      isFormEdit: false,
      scenario_master: false,
      upload_master: false,
      warehouse_master: false,
      vehicle_registration_master: false,
      gate_master: false,
      dock_master: false,
      zone_master: false,
      vendor_master: false,
      dockMappingMasters: false,
      vendorList: [],
      warehouseList: [],
      gateList: [],
      dockList: [],
      zoneList: [],
      vehicleList: [],
      vehicleNumberList: [],
      vehiclesRouteNumerList: [],
      routeNumerList: [],
      statuslist: [],
      stateList: [],
      cityList: [],
      cityListStateWise: [],
      routeList: [],
      scenarioForm: {
        title: null,
        description: null,
        is_level: false,
      },
      masterUploadName: null,
      textFileReports: [
        "tab_scan_report",
        "trip_challan",
        "scenario",
        "stc_contacts",
      ],
      search: {
        vehicle_registration_master: {
          vehicle_id: null,
        },
        warehouse_master: {
          warehouse_id: null,
        },
        gate_master: {
          gate_id: null,
        },
        dock_master: {
          dock_id: null,
        },
        zone_master: {
          zone_id: null,
        },
        vendor_master: {
          vendor_id: null,
        },
        map_dock_to_sector: {
          dock_id: null,
          zone_id: null,
        },
        ou_to_sector: {
          ou: null,
          zone_id: null,
        },
      },
      searchPanelName: "warehouse_master",
      masterUploadNameList: [
        {
          id: "scenario",
          label: "Scenario",
          url: "/create/bulk-scenarios",
          createUrl: "",
          key: "",
        },
        {
          id: "stc_contacts",
          label: "STC Contacts",
          url: "/create/bulk-stc-contacts",
          createUrl: "",
          key: "",
        },
      ],
      headers: {
        scenario: {
          "Scenario Title": "",
          "Scenario Description": "",
          "Level Applicable": "",
        },
        stc_contacts: {
          ZONE: "",
          EDC: "",
          "EDC Contact Number": "",
          STC: "",
          "STC Manager": "",
          "STC Contact Number": "",
          "Network Manager": "",
          "Network Contact Number": "",
          EDCH: "",
          "EDCH Contact Number": "",
        },
      },
      master: {
        forms: {
          map_dock_to_sector: {
            dock_id: null,
            zone_id: null,
            isEdit: false,
            dockList: [],
            zoneList: [],
            filterDockWiseZoneList: [],
          },
          warehouse_master: {
            warehouse_id: null,
            warehouse_name: null,
            city: null,
            location: null,
            state: null,
            pincode: null,
            latitude: null,
            longitude: null,
          },
          vehicle_registration_master: {
            vehicle_id: null,
            vehicle_type: null,
            vehicle_size: null,
            vehicle_tonnage: null,
            vendor_id: null,
            vehicle_number_plate: null,
            last_maintenance_date: null,
            next_maintenance_due_date: null,
            route: null,
          },
          gate_master: {
            gate_id: null,
            gate_name: null,
            gate_type: null,
            operational_hours: null,
            usage_type: null,
          },
          dock_master: {
            dock_id: null,
            dock_name: null,
            dock_type: null,
            dock_number: null,
            warehouse_id: null,
            dock_location: null,
            max_capacity: null,
            current_usage: null,
          },
          zone_master: {
            zone_id: null,
            zone_name: null,
            zone_type: null,
            zone_number: null,
            warehouse_id: null,
            zone_location: null,
            max_capacity: null,
            current_usage: null,
            safety_information: null,
          },
          vendor_master: {
            vendor_id: null,
            vendor_name: null,
          },
          shipment_booking_master: {
            vehicle_id: null,
            route_number: null,
          },
        },
        upload: {
          documentList: [],
          supportedExtensions: ["xls", "xlsx", "csv"],
          file: null,
          fileName: null,
          payload: [],
          isValidated: false,
          success: 0,
          failed: 0,
          updated: 0,
          totalcount: 0,
          pageCount: 0,
          page: 1,
          currPageNum: 0,
          pageoffset: 1,
          pagelimit: CONSTANT.LIMIT,
        },
      },
      stc_contact_Details: {
        url: "/contacts/getstcdetails",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
      },
      scenario_Details: {
        url: "/admin/get-allscenarios",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
      },
      escalation_config_Details: {
        url: "/escalation/getescalationdetails",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
      },
      torch: false,
      captures: {
        rc: {
          stream: null,
          file: null,
        },
      },
      photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
    };
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    this.getScenarios();
    // this.getWarehouseMaster()
    // this.getVendorList()
    // this.getWarehouseList()
    // this.getGateList()
    // this.getSectorList()
    // this.getVehicleList()

    // this.getStateList()
    // this.getCityList()
    // this.getDockList()
    // this.getZoneList()
    this.masterUploadName = "scenario";
    this.get_template_files(this.masterUploadName);
    setTimeout(function () {
      $("#commonaddmodule").attr("data-target", "#addbutton");
      $(".devEditEle").attr("data-target", "#addbutton");
    }, 1000);
  },
  methods: {
    getTemplateFile() {
      let header_name = this.masterUploadName;
      let headers = [this.headers[header_name]];
      let fileName = header_name;
      console.log(headers);
      this.getTemplate(headers, fileName);
    },
    validateScenario() {
      let isValid = true;
      if (!this.scenarioForm.title) {
        isValid = false;
      }
      if (!this.scenarioForm.description) {
        isValid = false;
      }
      return isValid;
    },
    formReset() {
      this.scenarioForm.title = null;
      this.scenarioForm.description = null;
    },
    senarioSubmit() {
      if (!this.validateScenario()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      try {
        let payload = {
          scenario: this.scenarioForm.title,
          description: this.scenarioForm.description,
          is_level: this.scenarioForm.is_level,
        };
        console.log(payload);
        this.makeRequest("POST", "/create/scenario", payload)
          .then((result) => {
            //console.log(result.data);
            this.isLoading = false;
            if (result && result.data && result.data.status) {
              this.sweetAlertSnackbar(result.data.message, "success");
              this.formReset();
            } else {
              this.sweetAlertSnackbar(result.data.message, "error");
            }
          })
          .catch((e) => {
            this.displayError(e);
          });
      } catch {
        this.displayError();
      }
    },
    dataChangeToString(data) {
      return data.join(",");
    },
    convertTimestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString(); // Adjust the format as needed
    },
    changeTimeToHours(timeinminutes) {
      const string = convertMinutesToTime3(timeinminutes);
      return string;
    },
    subRowOpened(value) {
      this.opened = value;
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    toggle(id) {
      const isOpen = this.opened === id;
      if (isOpen) {
        this.opened = null;
      } else {
        this.opened = id;
      }
    },

    async expandRow(id) {
      //console.log("clicked");
      const isOpen = this.opened === id;
      if (isOpen) {
        this.opened = null;
      } else {
        this.opened = id;
      }
    },
    toggleScenarios() {
      this.scenario_master = !this.scenario_master;
    },
    toggleStcContact() {
      this.$router.push("/escalation/stcform");
    },
    toggleEscalationMatrix() {
      this.$router.push("/escalation-configuration");
    },
    toggleUpload() {
      this.upload_master = !this.upload_master;
    },
    getStcContacts() {
      this.isMasterListLoading = true;
      let payload = {
        rows: this.stc_contact_Details.pagelimit,
        page: this.stc_contact_Details.pageoffset,
      };
      axios({
        method: "POST",
        url: this.stc_contact_Details.url,
        data: payload,
      })
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            this.stc_contact_Details.list = result.data.data.rows;
            this.stc_contact_Details.totalcount = result.data.data.count;
            this.stc_contact_Details.pageCount = Math.ceil(
              this.stc_contact_Details.totalcount /
                this.stc_contact_Details.pagelimit
            );
            //console.log(this.stc_contact_Details.list)
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            this.stc_contact_Details.totalcount = 0;
            this.stc_contact_Details.pageCount = 0;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getScenarios() {
      this.isMasterListLoading = true;
      let payload = {
        rows: this.scenario_Details.pagelimit,
        page: this.scenario_Details.pageoffset,
      };
      axios({
        method: "POST",
        url: this.scenario_Details.url,
        data: payload,
      })
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            //console.log(result.data)
            this.scenario_Details.list = result.data.data.rows;
            this.scenario_Details.totalcount = result.data.data.count;
            this.scenario_Details.pageCount = Math.ceil(
              this.scenario_Details.totalcount / this.scenario_Details.pagelimit
            );
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            this.scenario_Details.totalcount = 0;
            this.scenario_Details.pageCount = 0;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getEscalationList() {
      this.isMasterListLoading = true;
      let url = this.escalation_config_Details.url;
      let payload = {
        rows: this.escalation_config_Details.pagelimit,
        page: this.escalation_config_Details.pageoffset,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            //console.log(result.data)
            this.escalation_config_Details.list = result.data.data.rows;
            this.escalation_config_Details.totalcount = result.data.data.count;
            this.escalation_config_Details.pageCount = Math.ceil(
              this.escalation_config_Details.totalcount /
                this.escalation_config_Details.pagelimit
            );
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            this.escalation_config_Details.totalcount = 0;
            this.escalation_config_Details.pageCount = 0;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handleSearchPanelNameList() {},
    searchReset() {
      this.search = {
        vehicle_registration_master: {
          vehicle_id: null,
        },
        warehouse_master: {
          warehouse_id: null,
        },
        gate_master: {
          gate_id: null,
        },
        dock_master: {
          dock_id: null,
        },
        zone_master: {
          zone_id: null,
        },
        vendor_master: {
          vendor_id: null,
        },
        map_dock_to_sector: {
          dock_id: null,
          zone_id: null,
        },
        ou_to_sector: {
          ou: null,
          zone_id: null,
        },
      };
      this.searchPanel(this.searchPanelName);
    },
    async capturePhoto(id2, index = "") {
      let id = id2 + index;
      let canvas = document.querySelector(`#${id}-canvas`);
      let video = document.querySelector(`#${id}-video`);
      canvas.style.display = "block";
      let imgWidth = video.videoWidth ?? canvas.width;
      let imgHeight = video.videoHeight ?? canvas.height;
      this.width = video.videoWidth;
      this.height = video.videoHeight;
      var hRatio = canvas.width / imgWidth;
      var vRatio = canvas.height / imgHeight;
      var ratio = Math.min(hRatio, vRatio);
      var centerShift_x = (canvas.width - imgWidth * ratio) / 2;
      var centerShift_y = (canvas.height - imgHeight * ratio) / 2;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      this.PlaySound(`${id}-sound`);
      let image_data_url = canvas.toDataURL("image/jpeg");

      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      // data url of the image
      video.srcObject = null;
      const storeFile = (file) => {
        if (index !== "") {
          this.captures[id2][`file${index}`] = file;
        } else {
          this.captures[id2].file = file;
        }
      };
      document.querySelector(`#${id}-canvas`).toBlob(function (blob) {
        storeFile(new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }));
      }, "image/jpeg");
      if (this.captures[id2].stream) {
        this.captures[id2].stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      video.style.display = "none";
    },
    async turnOnCamera(id2, index = "") {
      this.isLoading = true;
      // Capture logic here
      let id = id2 + index;
      let video = document.getElementById(`${id}-video`);
      video.style.display = "block";

      let videoConstraints = {
        audio: false,
        video: {
          width: { ideal: 4096 },
          height: { ideal: 2160 },
          facingMode: {
            exact: "environment",
          },
        },
      };
      // let videoConstraints = { video: { facingMode: "user" }, audio: false }
      if (this.camera) {
        videoConstraints = { video: { facingMode: "user" }, audio: false };
      }
      // let videoConstraints = { video: { facingMode: "user" }, audio: false }
      try {
        let stream = await navigator.mediaDevices.getUserMedia(
          videoConstraints
        );
        let tracks = stream.getVideoTracks();
        if (this.torch) {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: true });
          }
        } else {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: false });
          }
        }
        this.captures[id2].stream = stream;
        video.srcObject = stream;
      } catch (e) {
        video.style.display = "none";
        this.displayError(e);
      }
      this.isLoading = false;
    },
    PlaySound(soundObjId) {
      var sound = document.getElementById(soundObjId);
      sound.play();
    },
    syncShipments() {
      this.isShipmentsSyncing = true;
      let url = "/shipments/sync-shipments";
      this.makeRequest("POST", url)
        .then((result) => {
          this.isShipmentsSyncing = false;
          this.master.upload.success = result.data.success;
          this.master.upload.failed = result.data.failed;
          this.master.upload.updated = result.data.updated;
          let error = result.data.error;
          if (error.length) {
            this.exportJsonData(error);
          }
          if (result.data.status) {
            this.sweetAlertSnackbar(result.data.message, "success", "top");
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.isShipmentsSyncing = false;
          this.displayError(e);
        });
    },
    getVehicleNumberList() {
      this.searchNameMasterList(
        "vehicle_registration_master",
        "vehicle_number_plate",
        null,
        "vehicle_id",
        "vehicle_transaction_type"
      )
        .then((result) => {
          this.vehicleNumberList = result.data;
          this.getRouteNumbers();
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getVehicleList() {
      this.searchNameMasterList(
        "vehicle_registration_master",
        "vehicle_number_plate",
        null,
        "vehicle_id"
      )
        .then((result) => {
          this.vehicleList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getRouteNumbers() {
      this.makeRequest(
        "post",
        "/routes/route-vehicle-controlling/get-routes-by-vehicle",
        []
      )
        .then((result) => {
          this.vehiclesRouteNumerList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handleVehicleChange(id) {
      this.master.forms.shipment_booking_master.route_number = null;
      if (id) {
        this.routeNumerList = this.vehiclesRouteNumerList.filter(
          (v) => v.vehicle_id == id
        );
      } else {
        this.routeNumerList = [];
      }
    },
    openEditForm(form, id) {
      this[form] = true;
      this.isFormEdit = true;
      this.populateEditForm(form, id);
    },
    populateEditForm(form, id) {
      let master = this.masterUploadNameList.find(
        (master) => master.id === form
      );
      if (master) {
        this.isLoading = true;
        let url = `/master/${form}/${id}?key=${master.key}`;
        this.makeRequest("GET", url)
          .then((result) => {
            this.isLoading = false;
            if (result.data.status) {
              this.master.forms[form] = result.data.data;
            } else {
              this[form] = false;
              this.isFormEdit = false;
            }
          })
          .catch((e) => {
            this[form] = false;
            this.isFormEdit = false;
            this.displayError(e);
          });
      } else {
        this[form] = false;
        this.isFormEdit = false;
        this.sweetAlertSnackbar("Master form was not found", "error");
      }
    },
    onFileSelect(e) {
      let currFile = e.target.files[0];
      this.master.upload.file = currFile;
      let fileName = currFile.name;
      this.master.upload.fileName = fileName;
      let masterUploadName = this.masterUploadName;
      $('input[type="file"]').val("");
      //console.log(this.textFileReports.includes(masterUploadName));

      if (this.textFileReports.includes(masterUploadName)) {
        this.master.upload.isValidated = true;
      }
      const callSnackbarDisplay = (error, type) =>
        this.sweetAlertSnackbar(error, type);
      const assignBulkUploadPayload = (payload) =>
        (this.master.upload.payload = payload);
      const assignIsValidated = (val) => {
        this.master.upload.isValidated = val;
        if (!val) {
          this.resetTemplateFileUploadData();
        }
      };
      if (currFile.size > 1024 * 1024 * 25) {
        this.sweetAlertSnackbar(
          "Document of size above 25MB is not allowed",
          "error"
        );
        return;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(currFile);
      let getColumnList = this.getColumnList;
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = read(data, {
          type: "array",
          cellDates: true,
          raw: false,
          dateNF: "dd-mm-yyyy",
        });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        let readData = utils.sheet_to_json(worksheet);
        console.log(masterUploadName);
        const { value, error } = schema[masterUploadName].validate(
          readData,
          schema.validationOptions
        );
        console.log(value);
        if (error) {
          let message =
            "ValidationError: Some fields were invalidated. Please fill the data properly and choose the file again.";
          if (error?.details) {
            message = error?.details[0].message.slice(0, 300);
            callSnackbarDisplay(message, "error");
          }
          assignIsValidated(false);
        } else {
          this.sweetAlertSnackbar(
            "Fields Validated, Click Upload button to save Attributes",
            "success"
          );
          let columns = getColumnList(masterUploadName);
          let payload = value.map((item) => {
            let obj = {};
            columns.forEach((col) => {
              if (col.format) {
                obj[col.id] = col.format(item[col.label]);
              } else {
                obj[col.id] = item[col.label];
              }
            });
            return obj;
          });
          console.log(payload);
          assignBulkUploadPayload(payload);
          assignIsValidated(true);
          // callSnackbarDisplay('Fields Validated, Click Upload button to save Attributes', 'success')
        }
      };
    },
    onSelectDoc(event) {
      let currFile = event.target.files[0];
      this.master.upload.file = currFile;
      let fileName = currFile.name;
      this.master.upload.fileName = fileName;
      let masterUploadName = this.masterUploadName;
      $('input[type="file"]').val("");
      let ext = fileName.split(".").pop().toLowerCase();
      if (
        !this.textFileReports.includes(masterUploadName) &&
        !this.master.upload.supportedExtensions.includes(ext)
      ) {
        this.sweetAlertSnackbar(`Invalid Extension`, "error");
        return;
      }
      if (
        this.textFileReports.includes(masterUploadName) &&
        !["txt"].includes(ext)
      ) {
        this.sweetAlertSnackbar(
          `Invalid Extension. Only .txt files are allowed`,
          "error"
        );
        return;
      }
      if (this.textFileReports.includes(masterUploadName)) {
        this.master.upload.isValidated = true;
        return;
      }

      const callSnackbarDisplay = (error, type) =>
        this.sweetAlertSnackbar(error, type);
      const assignBulkUploadPayload = (payload) =>
        (this.master.upload.payload = payload);
      const assignIsValidated = (val) => {
        this.master.upload.isValidated = val;
        if (!val) {
          this.resetTemplateFileUploadData();
        }
      };

      if (currFile.size > 1024 * 1024 * 25) {
        this.sweetAlertSnackbar(
          "Document of size above 25MB is not allowed",
          "error"
        );
        return;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(currFile);
      let getColumnList = this.getColumnList;
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = read(data, {
          type: "array",
          cellDates: true,
          raw: false,
          dateNF: "dd-mm-yyyy",
        });
        let sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        let readData = utils.sheet_to_json(worksheet);
        const { value, error } = schema[masterUploadName].validate(
          readData,
          schema.validationOptions
        );
        if (error) {
          let message =
            "ValidationError: Some fields were invalidated. Please fill the data properly and choose the file again.";
          if (error?.details) {
            message = error?.details[0].message.slice(0, 300);
          }
          callSnackbarDisplay(message, "error");
          assignIsValidated(false);
        } else {
          callSnackbarDisplay(
            "Fields Validated, Click Upload button to save Attributes",
            "success"
          );
          let columns = getColumnList(masterUploadName);
          let payload = value.map((item) => {
            let obj = {};
            columns.forEach((col) => {
              if (col.format) {
                obj[col.id] = col.format(item[col.label]);
              } else {
                obj[col.id] = item[col.label];
              }
            });
            return obj;
          });
          assignBulkUploadPayload(payload);
          assignIsValidated(true);
        }
      };
    },
    clickCallbackBulkUploadPage(pageNum) {
      this.master.upload.pageoffset = pageNum;
      this.master.upload.currPageNum = pageNum - 1;
      this.get_template_files();
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: $("#document-list").offset().top - 70,
        });
      }, 500);
    },
    saveUploadData() {
      let masterUploadName = this.masterUploadName;
      // if (this.textFileReports.includes(masterUploadName)) {
      //   this.uplodTextFileReport();
      //   return;
      // }
      let { url, caller } = this.masterUploadNameList.find(
        (item) => item.id === masterUploadName
      );
      let payload = this.master.upload.payload;

      if (masterUploadName === "shipment_booking_master") {
        if (!this.master.forms.shipment_booking_master.vehicle_id) {
          this.sweetAlertSnackbar(
            "Please select Vehicle for which shipments belongs!",
            "error"
          );
          return;
        }
        payload = payload.map((item) => {
          return {
            ...item,
            vehicle_id: this.master.forms.shipment_booking_master.vehicle_id,
            route_number:
              this.master.forms.shipment_booking_master.route_number,
          };
        });
      }
      this.isLoading = true;
      //console.log(payload);
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isLoading = false;
          if (result && result.data && result.data.status && result.data.data) {
            this.master.upload.success = result.data.data.success;
            this.master.upload.failed = result.data.data.failed;
            this.master.upload.updated = result.data.data.updated;
            //caller();
            this.UploadFiles();
            let error = result.data.data.error;
            console.log(error);
            if (error.length) {
              this.exportJsonData(error);
            }
          } else {
            this.sweetAlertSnackbar(`${result.data.message}`, "error");
          }
        })
        .catch((e) => {
          this.master.upload.file = null;
          this.master.upload.fileName = null;
          this.master.upload.payload = [];
          if (e?.response?.data?.data?.error) {
            let error = e.response.data.data.error;
            let fileName = e.response.data.data.fileName;
            if (error.length) {
              this.exportJsonData(error, `${fileName}_error`);
            }
          }
          this.displayError(e);
        });
    },
    UploadFiles() {
      this.isLoading = true;
      let masterUploadName = this.masterUploadName;
      let formData = new FormData();
      formData.append("file", this.master.upload.file);
      formData.append("folder", masterUploadName);
      formData.append("table", "ct_file_master");
      let url = "/files/s3/AddFileInFileMaster";
      console.log(formData);
      axios({
        "content-type": "multipart/form-data",
        method: "POST",
        url: url,
        data: formData,
      })
        .then((result) => {
          this.isLoading = false;
          this.master.upload.file = null;
          this.master.upload.fileName = null;
          this.master.upload.payload = [];
          this.get_template_files();
          if (result.data.status) {
            this.sweetAlertSnackbar(result.data.message, "success", "top");
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.master.upload.file = null;
          this.master.upload.fileName = null;
          this.master.upload.payload = [];
          this.displayError(e);
        });
    },
    uplodTextFileReport() {
      let masterUploadName = this.masterUploadName;
      let formData = new FormData();
      formData.append("file", this.master.upload.file);
      formData.append("folder", masterUploadName);
      formData.append("table", "file_master");
      let { url, caller } = this.masterUploadNameList.find(
        (item) => item.id === masterUploadName
      );
      axios({
        "content-type": "multipart/form-data",
        method: "POST",
        url: url,
        data: formData,
      })
        .then((result) => {
          this.isLoading = false;
          // this.get_template_files()
          this.master.upload.success = result.data.success;
          this.master.upload.failed = result.data.failed;
          this.master.upload.updated = result.data.updated;
          this.UploadFiles();
          let error = result.data.error;
          if (error.length) {
            this.exportJsonData(error);
          }
          if (result.data.status) {
            this.sweetAlertSnackbar(result.data.message, "success", "top");
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.master.upload.file = null;
          this.master.upload.fileName = null;
          this.master.upload.payload = [];
          if (e?.response?.data?.error) {
            let error = e.response.data.error;
            if (error.length) {
              this.exportJsonData(error);
            }
          }
          this.displayError(e);
        });
    },
    get_template_files(k = this.masterUploadName) {
      this.isMasterListLoading = true;
      let url = `/master/template/files?fileIdentifier=${k}`;
      let payload = {
        limit: CONSTANT.LIMIT,
        offset: this.master.upload.pageoffset,
      };
      axios({
        method: "POST",
        url,
        data: payload,
      })
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            this.master.upload.documentList = result.data.data.rows;
            this.master.upload.totalcount = result.data.data.count;
            this.master.upload.pageCount = Math.ceil(
              this.master.upload.totalcount / this.master.upload.pagelimit
            );
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            this.master.upload.documentList = [];
            this.master.upload.totalcount = 0;
            this.master.upload.pageCount = 0;
          }
        })
        .catch((e) => {
          this.isMasterListLoading = false;
          this.displayError(e);
        });
    },
    updateTemplateList(k) {
      if (k.id === this.masterUploadName) return;
      if (k.id === "shipment_booking_master") {
        // this.master.forms.shipment_booking_master.vehicle_id = null
        // this.master.forms.shipment_booking_master.route_number = null
        // this.getVehicleNumberList()
      }
      this.get_template_files(k.id);
    },
    resetTemplateFileUploadData() {
      console.log("clicked");
      this.master.upload.file = null;
      this.master.upload.fileName = null;
      this.master.upload.payload = null;
      this.master.upload.isValidated = false;
      this.master.upload.success = 0;
      this.master.upload.failed = 0;
      this.master.upload.updated = 0;
    },
    validateInput(inputType, fieldValue) {
      if (inputType === "latitude") {
        let latitude = fieldValue;
        return !isNaN(latitude) && latitude >= -90 && latitude <= 90;
      } else if (inputType === "longitude") {
        let longitude = fieldValue;
        return !isNaN(longitude) && longitude >= -180 && longitude <= 180;
      } else if (inputType === "pincode") {
        let pattern = /^[1-9][0-9]{5}$/;
        return pattern.test(fieldValue);
      } else if (inputType === "vehicle_number_plate") {
        let pattern =
          /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/;
        return pattern.test(
          this.master.forms.vehicle_registration_master.vehicle_number_plate
        );
      } else if (inputType === "whole_number") {
        return (
          Number.isInteger(parseFloat(fieldValue)) &&
          parseInt(fieldValue) >= 0 &&
          fieldValue !== null
        );
      } else if (inputType === "rating") {
        return (
          !Number.isInteger(fieldValue) &&
          parseInt(fieldValue) >= 0 &&
          parseInt(fieldValue) <= 5 &&
          fieldValue !== null
        );
      }
      return false;
    },
    dockNameSearch(name) {
      if (name && name.trim().length > 1) {
        this.searchNameMasterList("dock_master", "dock_name", name, "dock_id")
          .then((result) => {
            this.master.forms.map_dock_to_sector.dockList = result.data;
          })
          .catch((e) => {
            this.displayError(e);
          });
      }
    },
    toggleMasterCreate() {
      if (this.isFormEdit) {
        this.resetform("warehouse_master");
      }
      this.isFormEdit = false;
      this.warehouse_master = !this.warehouse_master;
    },
    togglevehicle_Registration() {
      if (this.isFormEdit) {
        this.resetform("vehicle_registration_master");
      }
      this.isFormEdit = false;
      this.vehicle_registration_master = !this.vehicle_registration_master;
      if (this.vehicle_registration_master) {
        this.getRoutes();
      }
    },
    toggleGatemaster() {
      if (this.isFormEdit) {
        this.resetform("gate_master");
      }
      this.isFormEdit = false;
      this.gate_master = !this.gate_master;
    },
    toggleDockmaster() {
      if (this.isFormEdit) {
        this.resetform("dock_master");
      }
      this.isFormEdit = false;
      this.dock_master = !this.dock_master;
    },
    togglZoneMaster() {
      if (this.isFormEdit) {
        this.resetform("zone_master");
      }
      this.isFormEdit = false;
      this.zone_master = !this.zone_master;
    },
    togglVendorMaster() {
      if (this.isFormEdit) {
        this.resetform("vendor_master");
      }
      this.isFormEdit = false;
      this.vendor_master = !this.vendor_master;
    },
    toggledocMappingCreate() {
      this.dockMappingMasters = !this.dockMappingMasters;
    },
    zoneNameSearch(name) {
      if (name && name.trim().length > 1) {
        this.searchNameMasterList("zone_master", "zone_name", name, "zone_id")
          .then((result) => {
            this.master.forms.map_dock_to_sector.zoneList = result.data;
          })
          .catch((e) => {
            this.displayError(e);
          });
      }
    },
    openAddForm() {
      this.master.forms.map_dock_to_sector.isEdit = false;
      this.resetform();
    },
    resetform(tab) {
      if (tab === "warehouse_master") {
        this.master.forms.warehouse_master.warehouse_name = null;
        this.master.forms.warehouse_master.city = null;
        this.master.forms.warehouse_master.location = null;
        this.master.forms.warehouse_master.state = null;
        this.master.forms.warehouse_master.pincode = null;
        this.master.forms.warehouse_master.latitude = null;
        this.master.forms.warehouse_master.longitude = null;
      } else if (tab === "vehicle_registration_master") {
        this.master.forms.vehicle_type = null;
        this.master.forms.vehicle_registration_master.vehicle_id = null;
        this.master.forms.vehicle_registration_master.vehicle_size = null;
        this.master.forms.vehicle_registration_master.vehicle_tonnage = null;
        this.master.forms.vehicle_registration_master.vendor_id = null;
        this.master.forms.vehicle_registration_master.vehicle_number_plate =
          null;
        this.master.forms.vehicle_registration_master.vehicle_type = null;
        this.master.forms.vehicle_registration_master.last_maintenance_date =
          null;
        this.master.forms.vehicle_registration_master.next_maintenance_due_date =
          null;
        this.master.forms.vehicle_registration_master.route = null;
        let canvases = document.getElementsByClassName("c");
        for (let element of canvases) {
          element.style.display = "none";
        }
        this.captures.rc.stream = null;
        this.captures.rc.file = null;
      } else if (tab === "gate_master") {
        this.master.forms.gate_master.gate_name = null;
        this.master.forms.gate_master.gate_type = null;
        this.master.forms.gate_master.operational_hours = null;
        this.master.forms.gate_master.usage_type = null;
      } else if (tab === "dock_master") {
        this.master.forms.dock_master.dock_name = null;
        this.master.forms.dock_master.dock_type = null;
        this.master.forms.dock_master.dock_number = null;
        this.master.forms.dock_master.warehouse_id = null;
        this.master.forms.dock_master.dock_location = null;
        this.master.forms.dock_master.max_capacity = null;
        this.master.forms.dock_master.current_usage = null;
      } else if (tab === "zone_master") {
        this.master.forms.zone_master.zone_name = null;
        this.master.forms.zone_master.zone_type = null;
        this.master.forms.zone_master.zone_number = null;
        this.master.forms.zone_master.warehouse_id = null;
        this.master.forms.zone_master.zone_location = null;
        this.master.forms.zone_master.max_capacity = null;
        this.master.forms.zone_master.current_usage = null;
        this.master.forms.zone_master.safety_information = null;
      } else if (tab === "vendor_master") {
        this.master.forms.vendor_master.vendor_name = null;
        // this.master.forms.vendor_master.contact_person = null
        // this.master.forms.vendor_master.contact_number = null
        // this.master.forms.vendor_master.email = null
        // this.master.forms.vendor_master.address = null
        // this.master.forms.vendor_master.city = null
        // this.master.forms.vendor_master.state = null
        // this.master.forms.vendor_master.pincode = null
        // this.master.forms.vendor_master.country = null
        // this.master.forms.vendor_master.vendor_rating = null
      } else if (tab === "map_dock_to_sector") {
        this.master.forms.map_dock_to_sector.dock_id = null;
        this.master.forms.map_dock_to_sector.zone_id = null;
      }
    },
    saveData(tab) {
      if (!this.validateForm(tab)) {
        this.sweetAlertSnackbar("Form was invalidated", "error");
        return;
      }
      let master = this.masterUploadNameList.find(
        (master) => master.id === tab
      );
      if (!master) {
        this.sweetAlertSnackbar("Master form was not found", "error");
        return;
      }
      this.isLoading = true;
      let payload = this.master.forms[tab];
      if (tab === "map_dock_to_sector") {
        payload = {
          dock_id: this.master.forms.map_dock_to_sector.dock_id,
          zone_id: this.master.forms.map_dock_to_sector.zone_id,
        };
      }
      let method = "POST";
      let url = master.createUrl;
      if (tab === "vehicle_registration_master" && this.captures.rc.file) {
        var formData = new FormData();
        formData.append("files", this.captures.rc.file);
        formData.append("folder", "vehicle_registration_master");
        axios({
          "content-type": "multipart/form-data",
          method: "POST",
          url: "/files/s3/bulkUploadFiles",
          data: formData,
        })
          .then((result) => {
            if (result.data.status) {
              let files = result.data.data;
              for (let file of files) {
                payload.rc_photo = file.fileKey;
              }
              this.makeRequest(method, url, payload)
                .then((result) => {
                  this.isFormEdit = false;
                  this.isLoading = false;
                  if (result && result.data && result.data.status) {
                    this.resetform(tab);
                    this.getVehicleRegistrationMaster();
                    this.sweetAlertSnackbar(result.data.message, "success");
                  } else {
                    this.sweetAlertSnackbar(result.data.message, "error");
                  }
                })
                .catch((e) => {
                  this.isFormEdit = false;
                  this.displayError(e);
                });
            } else {
              this.sweetAlertSnackbar(result.data.message, "error");
            }
          })
          .catch((e) => {
            this.displayError(e);
          });
      } else {
        this.makeRequest(method, url, payload)
          .then((result) => {
            this.isFormEdit = false;
            this.isLoading = false;
            if (result && result.data && result.data.status) {
              this.resetform(tab);
              if (tab === "warehouse_master") {
                this.getWarehouseMaster();
                this.getWarehouseList();
              } else if (tab === "vehicle_registration_master") {
                this.getVehicleRegistrationMaster();
              } else if (tab === "gate_master") {
                this.getGateMaster();
              } else if (tab === "dock_master") {
                this.getDockMaster();
                this.getDockList();
              } else if (tab === "zone_master") {
                this.getZoneMaster();
                this.getZoneList();
              } else if (tab === "vendor_master") {
                this.getVendorMaster();
                this.getVendorList();
              } else if (tab === "map_dock_to_sector") {
                this.getZoneToDockMapping();
              }
              this.sweetAlertSnackbar(result.data.message, "success");
            } else {
              this.sweetAlertSnackbar(result.data.message, "error");
            }
          })
          .catch((e) => {
            this.isFormEdit = false;
            this.displayError(e);
          });
      }
    },
    disabledPastDates(date) {
      if (!this.master.forms.vehicle_registration_master.last_maintenance_date)
        return false;
      let dayBefore = moment(
        this.master.forms.vehicle_registration_master.last_maintenance_date
      ).format("YYYY-MM-DD");
      const beforeToday = new Date(dayBefore);
      beforeToday.setHours(0, 0, 0, 0);
      return date < beforeToday;
    },
    clearDate() {
      this.master.forms.vehicle_registration_master.next_maintenance_due_date =
        null;
    },
    validateForm(tab) {
      let isValid = true;
      let formValues = this.master.forms[tab];
      if (tab === "warehouse_master") {
        if (
          !this.getTrimmedString(formValues.warehouse_name) ||
          !this.getTrimmedString(formValues.city) ||
          !this.getTrimmedString(formValues.location) ||
          !this.getTrimmedString(formValues.state) ||
          !this.getTrimmedString(formValues.pincode) ||
          (this.getTrimmedString(formValues.latitude) &&
            !this.validateInput("latitude", formValues.latitude)) ||
          (this.getTrimmedString(formValues.latitude) &&
            !this.validateInput("longitude", formValues.longitude)) ||
          !this.validateInput("pincode", formValues.pincode)
        ) {
          isValid = false;
        }
      } else if (tab === "vehicle_registration_master") {
        if (
          !this.getTrimmedString(formValues.vehicle_size) ||
          !this.getTrimmedString(formValues.vehicle_number_plate) ||
          !formValues.vendor_id
        ) {
          isValid = false;
        }
        if (
          !this.isFormEdit &&
          (!formValues.route || (formValues.route && !formValues.route.length))
        ) {
          isValid = false;
        }
      } else if (tab === "gate_master") {
        if (
          !this.getTrimmedString(formValues.gate_name) ||
          !this.getTrimmedString(formValues.operational_hours) ||
          !this.getTrimmedString(formValues.usage_type) ||
          !formValues.gate_type
        ) {
          isValid = false;
        }
      } else if (tab === "dock_master") {
        if (
          !this.getTrimmedString(formValues.dock_name) ||
          !this.getTrimmedString(formValues.dock_type) ||
          !this.getTrimmedString(formValues.dock_number) ||
          !formValues.warehouse_id ||
          !this.getTrimmedString(formValues.dock_location) ||
          (this.getTrimmedString(formValues.max_capacity) &&
            !this.validateInput("whole_number", formValues.max_capacity)) ||
          (this.getTrimmedString(formValues.current_usage) &&
            !this.validateInput("whole_number", formValues.current_usage))
        ) {
          isValid = false;
        }
      } else if (tab === "zone_master") {
        if (
          !this.getTrimmedString(formValues.zone_name) ||
          !this.getTrimmedString(formValues.zone_type) ||
          !this.getTrimmedString(formValues.zone_number) ||
          !formValues.warehouse_id ||
          !this.getTrimmedString(formValues.zone_location)
        ) {
          isValid = false;
        }
      } else if (tab === "vendor_master") {
        if (!this.getTrimmedString(formValues.vendor_name)) {
          isValid = false;
        }
      } else if (tab === "map_dock_to_sector") {
        if (
          !this.master.forms.map_dock_to_sector.dock_id ||
          !this.master.forms.map_dock_to_sector.zone_id ||
          (this.master.forms.map_dock_to_sector.zone_id &&
            !this.master.forms.map_dock_to_sector.zone_id.length)
        ) {
          isValid = false;
        }
      } else {
        isValid = false;
      }

      return isValid;
    },
    searchPanel(tab) {
      let currTab = document.getElementById(`${tab}_tab`);
      if (currTab) {
        currTab.click();
      }
      if (tab === "warehouse_master") {
        this.getWarehouseMaster();
      } else if (tab === "gate_master") {
        this.getGateMaster();
      } else if (tab === "dock_master") {
        this.getDockMaster();
      } else if (tab === "zone_master") {
        this.getZoneMaster();
      } else if (tab === "vendor_master") {
        this.getVendorMaster();
      } else if (tab === "vehicle_registration_master") {
        this.getVehicleRegistrationMaster();
      }
      // else if(tab === "map_dock_to_sector") {
      //     this.getZoneToDockMapping()
      // }
    },
    getWarehouseMaster() {
      this.isMasterListLoading = true;
      let url = "/master/warehouses";
      let searchDetails = this.search.warehouse_master;
      let payload = {
        ...searchDetails,
        page: this.master.warehouse_master.page,
        rows: this.master.warehouse_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.warehouse_master.list = result.data.data.rows;
          this.master.warehouse_master.totalcount = result.data.data.count;
          this.master.warehouse_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getVehicleRegistrationMaster() {
      // this.getRoutes()
      this.isMasterListLoading = true;
      let url = "/master/vehicle_registrations";
      let searchDetails = this.search.vehicle_registration_master;
      let payload = {
        ...searchDetails,
        page: this.master.vehicle_registration_master.page,
        rows: this.master.vehicle_registration_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.vehicle_registration_master.list = result.data.data.rows;
          this.master.vehicle_registration_master.totalcount =
            result.data.data.count;
          this.master.vehicle_registration_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getRoutes() {
      this.searchNameMasterList(
        "route_details",
        "route_path",
        null,
        "route_number"
      )
        .then((result) => {
          this.routeList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getGateMaster() {
      this.isMasterListLoading = true;
      let url = "/master/gates";
      let searchDetails = this.search.gate_master;
      let payload = {
        ...searchDetails,
        page: this.master.vehicle_registration_master.page,
        rows: this.master.vehicle_registration_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.gate_master.list = result.data.data.rows;
          this.master.gate_master.totalcount = result.data.data.count;
          this.master.gate_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getDockMaster() {
      this.isMasterListLoading = true;
      let url = "/master/docks";
      let searchDetails = this.search.dock_master;
      let payload = {
        ...searchDetails,
        page: this.master.dock_master.page,
        rows: this.master.dock_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.dock_master.list = result.data.data.rows;
          this.master.dock_master.totalcount = result.data.data.count;
          this.master.dock_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getZoneMaster() {
      this.isMasterListLoading = true;
      let url = "/master/zones";
      let searchDetails = this.search.zone_master;
      let payload = {
        ...searchDetails,
        page: this.master.zone_master.page,
        rows: this.master.zone_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.zone_master.list = result.data.data.rows;
          this.master.zone_master.totalcount = result.data.data.count;
          this.master.zone_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getVendorMaster() {
      this.isMasterListLoading = true;
      let url = "/master/vendors";
      let searchDetails = this.search.vendor_master;
      let payload = {
        ...searchDetails,
        page: this.master.vendor_master.page,
        rows: this.master.vendor_master.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.vendor_master.list = result.data.data.rows;
          this.master.vendor_master.totalcount = result.data.data.count;
          this.master.vendor_master.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getZoneToDockMapping() {
      this.isMasterListLoading = true;
      let url = "/master/mapping/dock-to-zone";
      let searchDetails = this.search.map_dock_to_sector;
      let payload = {
        ...searchDetails,
        page: this.master.map_dock_to_sector.page,
        rows: this.master.map_dock_to_sector.pagelimit,
      };
      this.makeRequest("POST", url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this.master.map_dock_to_sector.list = result.data.data.rows;
          this.master.map_dock_to_sector.totalcount = result.data.data.count;
          this.master.map_dock_to_sector.pageCount = Math.ceil(
            result.data.data.count / this.master.pagelimit
          );
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    selectstatus() {},
    date() {},
    getVendorList() {
      this.searchNameMasterList(
        "vendor_master",
        "vendor_name",
        null,
        "vendor_id"
      )
        .then((result) => {
          this.vendorList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getWarehouseList() {
      this.searchNameMasterList(
        "warehouse_master",
        "warehouse_name",
        null,
        "warehouse_id"
      )
        .then((result) => {
          this.warehouseList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getGateList() {
      this.searchNameMasterList("gate_master", "gate_name", null, "gate_id")
        .then((result) => {
          this.gateList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getSectorList() {
      this.searchNameMasterList("zone_master", "zone_name", null, "zone_id")
        .then((result) => {
          this.zoneList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getStateList() {
      this.searchNameMasterList("state", "state_name", null, "state_name")
        .then((result) => {
          this.stateList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getCityList() {
      this.searchNameMasterList(
        "state_city_map",
        "city_name",
        null,
        "city_name",
        "state_name"
      )
        .then((result) => {
          this.cityList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    filterCityListStateWise(state) {
      if (!this.isFormEdit) {
        this.master.forms.warehouse_master.city = null;
        this.master.forms.vendor_master.city = null;
      }
      this.cityListStateWise = this.cityList.filter(
        (city) => city.field === state
      );
    },
    getDockList() {
      this.searchNameMasterList(
        "dock_master",
        "dock_name",
        null,
        "dock_id",
        "warehouse_id"
      )
        .then((result) => {
          this.master.forms.map_dock_to_sector.dockList = result.data;
          this.dockList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getZoneList(dock) {
      this.searchNameMasterList(
        "zone_master",
        "zone_name",
        null,
        "zone_id",
        "warehouse_id"
      )
        .then((result) => {
          this.master.forms.map_dock_to_sector.zoneList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    filterZoneListDockWise(dock) {
      this.master.forms.map_dock_to_sector.zone_id = null;
      let dockForWarehouse = this.master.forms.map_dock_to_sector.dockList.find(
        (i) => i.id == dock
      );
      if (dockForWarehouse) {
        this.master.forms.map_dock_to_sector.filterDockWiseZoneList =
          this.master.forms.map_dock_to_sector.zoneList.filter(
            (i) => i.field == dockForWarehouse.field
          );
      } else {
        this.master.forms.map_dock_to_sector.filterDockWiseZoneList = [];
      }
    },
    handlePageChange(pageNum, tab) {
      console.log(pageNum);
      console.log(tab);
      this[tab].pageoffset = pageNum;
      this[tab].currPageNum = pageNum - 1;
      if (tab === "scenario_Details") {
        this.getScenarios();
      } else if (tab === "stc_contact_Details") {
        this.getStcContacts();
      }
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}

.requiredField {
  margin-left: 2px;
  color: red;
}

#overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}
</style>
